<template>
  <footer class="ba-flex ba-items-center ba-justify-between">
    <button
      type="reset"
      class="btn btn--cancel xs:ba-flex-shrink-0 ba-w-full xs:ba-w-40 ba-mr-4 u-mb-0"
    >
      {{ $t('button.cancel') }}
    </button>
    <button
      type="submit"
      :disabled="submitDisabled"
      class="btn btn--login xs:ba-flex-shrink-0 ba-w-full xs:ba-w-56 u-mb-0"
      :style="submitDisabled ? { opacity: 0.38 } : null"
    >
      {{ submitLabel }}
    </button>
  </footer>
</template>

<script>
export default {
  name: "v-page-manage-controls",
  props: {
    submitLabel: {
      type: String,
      default: null
    },
    submitDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
